<template>
  <layout-default-filters @open="$_OnOpen" @apply="$_applyQueryString"
  :hideButton="filtroInicial">
    <template #superior>
    <div class='div-geral'>
      <div class='primeiro-filtro' :class="{ 'is-hidden': filtroInicial }">
        <v-form ref="form" >
          <core-date-picker-field clearable
            v-model="filters.createdFrom"
            label="De"
          />

          <core-date-picker-field clearable
            v-model="filters.createdBefore"
            label="Até"
            :rules="createdBeforeRules"
          />
        </v-form >
      </div>

      <div class='segundo-filtro' :class="{ 'is-raised': filtroInicial }">

        <div v-if="filtroAtivo === null">
          <core-text-field
            clearable class='txt-filter'
            @focus="ativarFiltro('pessoa')"
            v-model="nomePessoa"
            min="0"
            @keydown="bloquearCaracteresInvalidos"
            @input="garantirPositivo('cliente')"
            label='Pessoa'
            :type='inputType'
          />
          <core-text-field
            clearable class='txt-filter'
            @focus="ativarFiltro('tipo')"
            v-model="nomeTipo"
            min="0"
            @keydown="bloquearCaracteresInvalidos"
            @input="garantirPositivo('cliente')"
            label='Tipo'
            :type='inputType'
          />
        </div>

        <div v-if="filtroAtivo === 'pessoa'">
          <div class='radios' :class="{ 'visible': filtroAtivo === 'pessoa' }">
            <v-radio-group v-model="radioPessoa" row>
              <v-radio
                v-for="n in 2"
                :key="n"
                :label="radioLabelPessoa[n - 1]"
                :value="n"
              ></v-radio>
            </v-radio-group>
          </div>
          <core-text-field
            clearable class='txt-filter'
            @focus="ativarFiltro('pessoa')"
            v-model="nomePessoa"
            label='Pessoa'
            min="0"
            @keydown="bloquearCaracteresInvalidos"
            @input="garantirPositivo('cliente')"
            :type='inputType'
          />
          <div class='btns-wrap' :class="{ 'visible': filtroAtivo === 'pessoa' }">
            <v-btn rounded color='primary' class='btns' @click='$_load(0)'>
              <v-icon>mdi-arrow-left-thick</v-icon>
            </v-btn>
            <v-btn rounded color='primary' class='btns reducesize' @click='$_load(1)'>
              <v-icon>mdi-arrow-left-thick</v-icon><v-icon>mdi-arrow-right-thick</v-icon>
            </v-btn>
            <v-btn rounded color='primary' class='btns-mini' @click='$_load(2)'>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <template v-if="filtroAtivo === 'pessoa'">
            <v-divider></v-divider>
            <div
              class="mx-auto cardlist"
              max-width="500"
              >
              <v-list two-line class='scroll'>
                <v-list-item-group
                  active-class="green--text"
                  multiple
                >
                  <template v-for="(item, index) in itemsPessoa">
                    <v-list-item :key="item.id + '-' + index">
                      <v-card class='cardpessoa' @click="$_onClickCard(item.nome, item.idcliente)">
                        {{ item.idcliente }} - {{ item.nome }}
                      </v-card>
                    </v-list-item>

                    <v-divider
                      v-if="index < itemsPessoa.length - 1"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list-item-group>
              </v-list>
            </div>
            <v-divider></v-divider>
          </template>
        </div>

        <div v-if="filtroAtivo === 'tipo'">
          <div class='radios' :class="{ 'visible': filtroAtivo === 'tipo' }">
            <v-radio-group v-model="radioTipo" row>
              <v-radio
                v-for="n in 2"
                :key="n"
                :label="radioLabelTipo[n - 1]"
                :value="n"
              ></v-radio>
            </v-radio-group>
          </div>
          <core-text-field
            clearable class='txt-filter'
            @focus="ativarFiltro('tipo')"
            v-model="nomeTipo"
            min="0"
                @keydown="bloquearCaracteresInvalidos"
                @input="garantirPositivo('cliente')"
            label='Tipo'
            :type='inputType'
          />
          <div class='btns-wrap' :class="{ 'visible': filtroAtivo === 'tipo' }">
            <v-btn rounded color='primary' class='btns' @click='$_load(0)'>
              <v-icon>mdi-arrow-left-thick</v-icon>
            </v-btn>
            <v-btn rounded color='primary' class='btns reducesize' @click='$_load(1)'>
              <v-icon>mdi-arrow-left-thick</v-icon><v-icon>mdi-arrow-right-thick</v-icon>
            </v-btn>
            <v-btn rounded color='primary' class='btns-mini' @click='$_load(2)'>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <template v-if="filtroAtivo === 'tipo'">
            <v-divider></v-divider>
            <div
              class="mx-auto cardlist"
              max-width="500"
              >
              <v-list two-line class='scroll'>
                <v-list-item-group
                  active-class="green--text"
                  multiple
                >
                  <template v-for="(item, index) in itemsTipo">
                    <v-list-item :key="item.id + '-' + index">
                      <v-card class='cardpessoa' @click="$_onClickCard(item.descricao, item.idtipopedidovenda)">
                        {{ item.idtipopedidovenda }} - {{ item.descricao }}
                      </v-card>
                    </v-list-item>

                    <v-divider
                      v-if="index < itemsTipo.length - 1"
                      :key="index"
                    ></v-divider>
                  </template>
                </v-list-item-group>
              </v-list>
            </div>
            <v-divider></v-divider>
          </template>
        </div>
        
      </div>
    </div>
    </template>
  </layout-default-filters>
</template>

<script>
import {  mapMutations } from 'vuex';
import db from '@/plugins/dexie';

import { PRODUTO_QUERIES } from '@/constants/QUERY_FILTERS';
import { PRODUTO_STORAGE } from '@/constants/STORAGE';

import { getQueryValue, setQueryValue } from '@/services/query-string';
import LayoutDefaultFilters from '@/layouts/default/NewFilters.vue';
import CoreDatePickerField from '@/components/core/date-picker-field/Index.vue';
import CoreTextField from '@/components/core/text-field/Index.vue';
import errorHandler from '@/utils/error-handler';
import storage from '@/services/storage';

export default {
  name: 'ViewVendasFilters',

  components: {
    LayoutDefaultFilters,
    CoreDatePickerField,
    CoreTextField,
  },

  data() {
    const hoje = new Date().toISOString().split('T')[0];
    return {
      filtroAtivo: null,
      filtroInicial: true,
      inputType: 'text',
      loading: false,

      itemsPessoa: [],
      radioPessoa: 2,
      radioLabelPessoa: ['Código', 'Nome'],
      nomePessoa: null,

      itemsTipo: [],
      radioTipo: 2,
      radioLabelTipo: ['Código', 'Descrição'],
      nomeTipo: null,

      filters: {
        createdFrom: hoje,
        createdBefore: hoje,
        codigopessoa: null,
        idtipopedidovenda: null,
      },
      createdBeforeRules: [
        () => {
          const from = new Date(this.filters.createdFrom);
          const to = new Date(this.filters.createdBefore);
          return to >= from || 'Data Final deve ser superior a Data Inicial';
        },
      ],
    };
  },

  mounted() {
    this.subirForm(true); 

    this.$nextTick(() => {
      this.$_applyQueryString();
    });
  },

  methods: {
    ...mapMutations({
      $_setRefresh: 'filter/refresh',
    }),

    garantirPositivo() {
      if (this.termoBusca && this.termoBusca < 0) {
        this.termoBusca = Math.abs(this.termoBusca).toString();
      }
    },

    bloquearCaracteresInvalidos(e) {
      if (['-', '+'].includes(e.key)) {
        e.preventDefault();
      }
    },

    ativarFiltro(nomeFiltro) {
      this.filtroAtivo = nomeFiltro;
      if (!this.filtroInicial) {
        this.subirForm(true);
      }
      this.$_load(1);
    },

    async $_load(parametroLoad) {
      this.loading = true;
      try {
        if (parametroLoad === 2) {
          if (this.filtroAtivo === 'pessoa') {
            this.nomePessoa = null;
            this.filters.codigopessoa = null;
            storage.setItem(PRODUTO_STORAGE.textofiltro, '');
            this.itemsPessoa = [];
          } else if (this.filtroAtivo === 'tipo') {
            this.nomeTipo = null;
            this.itemsTipo = [];
            this.filters.idtipopedidovenda = null;
          }
          this.subirForm(0);
          this.loading = false;
          return;
        }

        if (this.filtroAtivo === 'pessoa') {
          // Verificação alterada: Só busca se houver texto digitado e não for apenas espaços
          if (this.nomePessoa && this.nomePessoa.trim() !== '') {
            if (this.radioPessoa === 2) {
              if (parametroLoad === 0) {
                this.itemsPessoa = await db.cliente
                  .where('nome')
                  .startsWithIgnoreCase(this.nomePessoa)
                  .limit(100)
                  .toArray();
              } else {
                const termoLower = this.nomePessoa.toLowerCase();
                this.itemsPessoa = await db.cliente
                  .filter(cliente => cliente.nome && cliente.nome.toLowerCase().includes(termoLower))
                  .limit(100)
                  .toArray();
              }
            } else {
              const codInt = parseInt(this.nomePessoa, 10) || 0;
              this.itemsPessoa = await db.cliente
                .where('idcliente')
                .equals(codInt)
                .toArray();
            }
          } else {
            this.itemsPessoa = [];
            this.filters.codigopessoa = null;
            storage.setItem(PRODUTO_STORAGE.textofiltro, '');
          }
        } 
        
        else if (this.filtroAtivo === 'tipo') {
          if (this.nomeTipo && this.nomeTipo.trim() !== '') {
            if (this.radioTipo === 2) {
              if (parametroLoad === 0) {
                this.itemsTipo = await db.tipopedidovenda
                  .where('descricao')
                  .startsWithIgnoreCase(this.nomeTipo)
                  .limit(50)
                  .toArray();
              } else {
                const termoLower = this.nomeTipo.toLowerCase();
                this.itemsTipo = await db.tipopedidovenda
                  .filter(tipo => tipo.descricao && tipo.descricao.toLowerCase().includes(termoLower))
                  .limit(50)
                  .toArray();
              }
            } else {
              const codInt = parseInt(this.nomeTipo, 10) || 0;
              this.itemsTipo = await db.tipopedidovenda
                .where('idtipopedidovenda')
                .equals(codInt)
                .toArray();
            }
          } else {
            this.itemsTipo = [];
            this.filters.idtipopedidovenda = null;
          }
        } else {
          this.itemsPessoa = [];
          this.itemsTipo = [];
        }
      } catch (err) {
        errorHandler.call(this, err);
      } finally {
        this.loading = false;
      }
    },

    $_applyQueryString() {
      sessionStorage.setItem('filtros_salvos_pedidos', JSON.stringify(this.filters));
      setQueryValue(PRODUTO_QUERIES.createdFrom, this.filters.createdFrom);
      setQueryValue(PRODUTO_QUERIES.createdBefore, this.filters.createdBefore);
      setQueryValue(PRODUTO_QUERIES.codigopessoa, this.filters.codigopessoa);
      setQueryValue(PRODUTO_QUERIES.idtipopedidovenda || 'idtipopedidovenda', this.filters.idtipopedidovenda);
      this.$_setRefresh('S');
    },

    $_OnOpen() {
      this.subirForm(false);
    },

    subirForm(bool) {
      if (bool) {
        if (this.filtroInicial) { return; }
        document.querySelector('.primeiro-filtro').style.opacity = '0';
        document.querySelector('.primeiro-filtro').style.zIndex = '-1';
        if (this.$_isMobile) document.querySelector('.segundo-filtro').style.top = '-210px';
        else document.querySelector('.segundo-filtro').style.top = '-180px';
        
        this.filtroInicial = true;

      } else {
        if (!this.filtroInicial) { return; }
        document.querySelector('.primeiro-filtro').style.opacity = '1';
        document.querySelector('.primeiro-filtro').style.zIndex = '2';
        if (this.$_isMobile) document.querySelector('.segundo-filtro').style.top = '0';
        else document.querySelector('.segundo-filtro').style.top = '0';
        
        this.filtroInicial = false;
        this.filtroAtivo = null;
      }
    },

    $_onClickCard(nome, codigo) {
      if (this.filtroInicial) {
        if (this.filtroAtivo === 'pessoa') {
          this.nomePessoa = `${codigo} - ${nome}`;
          storage.setItem(PRODUTO_STORAGE.textofiltro, this.nomePessoa);
          this.filters.codigopessoa = codigo;
        } else if (this.filtroAtivo === 'tipo') {
          this.nomeTipo = `${codigo} - ${nome}`;
          this.filters.idtipopedidovenda = codigo;
        }
        
        this.subirForm(0);
      }
    },
  },

watch: {
  nomePessoa(novoValor) {
    if (!novoValor || novoValor.trim() === '') {
      this.filters.codigopessoa = null;
      this.itemsPessoa = [];
      storage.setItem(PRODUTO_STORAGE.textofiltro, '');
    }
  },

  nomeTipo(novoValor) {
    if (!novoValor || novoValor.trim() === '') {
      this.filters.idtipopedidovenda = null;
      this.itemsTipo = [];
    }
  },

  $route: {
    deep: true,
    immediate: true,
    handler() {

      if (Object.keys(this.$route.query).length === 0) {
        const filtrosSalvos = sessionStorage.getItem('filtros_salvos_pedidos');
        if (filtrosSalvos) {
          this.filters = JSON.parse(filtrosSalvos);
          
          this.$nextTick(() => {
            this.$_applyQueryString();
          });
          return;
        }
      }

      const hoje = new Date().toISOString().split('T')[0];
      this.filters.createdFrom = getQueryValue(PRODUTO_QUERIES.createdFrom, hoje);
      this.filters.createdBefore = getQueryValue(PRODUTO_QUERIES.createdBefore, hoje);
      this.filters.codigopessoa = getQueryValue(PRODUTO_QUERIES.codigopessoa, null);
      this.filters.idtipopedidovenda = getQueryValue(PRODUTO_QUERIES.idtipopedidovenda || 'idtipopedidovenda', null);

      storage.getItem(PRODUTO_STORAGE.textofiltro).then((result) => {
        if (result && this.filters.codigopessoa) {
          this.nomePessoa = result;
        }
      });
      
      if (this.filters.idtipopedidovenda && !this.nomeTipo) {
        const idInt = parseInt(this.filters.idtipopedidovenda, 10);
        db.tipopedidovenda.where('idtipopedidovenda').equals(idInt).first().then(item => {
            if (item) {
              this.nomeTipo = `${item.idtipopedidovenda} - ${item.descricao}`;
            }
        });
      }
    },
  },
},
};
</script>

<style scoped>
  .div-geral {
    height: 0%;
  }

  .btns-wrap {
    display: flex;
    justify-content: space-around;
    height: 50px;
    transition: opacity 0.3s;
    opacity: 0;
  }

  .btns {
    width: 33%;
    transition: opacity 0.3s;
  }

  .btns-mini {
    width: 10%;
    transition: opacity 0.3s;
  }

  .primeiro-filtro {
    transition: opacity 0.3s;
    position: relative;
    opacity: 1;
    z-index: 1;
  }

  .segundo-filtro {
    transition: top 0.4s;
    position: relative;
    z-index: 1;
    height: 0px;
  }

  .radios {
    transition: opacity 0.3s;
    opacity: 0;
    height: 48px; 
  }

  .radios.visible,
  .btns-wrap.visible {
    opacity: 1;
  }


  .mx-auto.cardlist {
    transition: opacity 0.3s;
    transition: top 0.4s; 
    height: 50vh;
    overflow-y: scroll;
    background-color: rgb(245, 245, 245);
  }

  .cardpessoa {
    height: 80px;
    width: 100%;
    margin-top: 5px;
  }

  .txt-filter {
    height: 50px;
  }

  .primeiro-filtro.is-hidden {
  opacity: 0;
  z-index: -1;
}

.segundo-filtro.is-raised {
  top: -210px; /* ou -180px para desktop */
}
</style>